<template>
  <div class="registration-view">
    <Registration />
  </div>
</template>

<script>
import Registration from '@/components/Registration.vue'

export default {
  components: {
    Registration,
  },
}
</script>
<style scoped>
.registration-view {
  min-height: 100%;
}
</style>
